import axios from "axios";
export const GET_SERVICES = "GET_SERVICES";
export const CHANGE_SERVICE_AVAILABILITY = "CHANGE_SERVICE_AVAILABILITY";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const ADD_SERVICE = "ADD_SERVICE";
export const GET_PROVIDER_SERVICES_BY_NOMENCLATURA = "GET_PROVIDER_SERVICES_BY_NOMENCLATURA";
export const UPDATE_PROVIDED_SERVICE_AVAILABILITY = "UPDATE_PROVIDED_SERVICE_AVAILABILITY";
export const REMOVE_PROVIDED_SERVICE_BY_ID = "REMOVE_PROVIDED_SERVICE_BY_ID";

export const GET_NOMENCLATURES = "GET_NOMENCLATURES";

export const GET_PRACTICES = "GET_PRACTICES";
export const DELETE_PROVIDER_PRACTICE = "DELETE_PROVIDER_PRACTICE";
export const REMOVE_PROVIDER_PRACTICE_BY_ID = "REMOVE_PROVIDER_PRACTICE_BY_ID";
export const ADD_PROVIDER_PRACTICE = "ADD_PROVIDER_PRACTICE";
export const CHANGE_PRACTICE_AVAILABILITY = "CHANGE_PRACTICE_AVAILABILITY";
export const UPDATE_PROVIDER_PRACTICE_AVAILABILITY = "UPDATE_PROVIDER_PRACTICE_AVAILABILITY";

export const getServices = (artId) => (dispatch) => {
  return dispatch({
    type: GET_SERVICES,
    payload: axios
      .get(`providedService?wriId=${artId}`)
      .then((response) => ({ data: response.data }))
  });
}
export const changeServiceAvailability = (art, subnomenclador, prestacion, habilitado) => (dispatch) => {
  return dispatch({
    type: CHANGE_SERVICE_AVAILABILITY,
    payload: axios.put(`providedService/changeAvailability`, { art, subnomenclador, prestacion, habilitado })
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      })
  });
}
export const getNomenclatures = (artId) => (dispatch) => {
  return dispatch({
    type: GET_NOMENCLATURES,
    payload: axios
      .get(`providedService/subnomenclatures?wriId=${artId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  });
}

export const deleteService = (wriId, service, subnomenclature) => (dispatch) => {
  return dispatch({
    type: DELETE_SERVICE,
    payload: axios.delete(`providedService?wriId=${wriId}&service=${service}&subnomenclature=${subnomenclature}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  })
}

export const addService = (values) => (dispatch) => {
  return dispatch({
    type: ADD_SERVICE,
    payload: axios.post(`providedService`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  })
}

export const removeProvidedServiceById = (prestacion, subnomenclador) => (dispatch) => {
  return dispatch({
    type: REMOVE_PROVIDED_SERVICE_BY_ID,
    payload: { prestacion, subnomenclador }
  })
}

export const updateProvidedServiceAvailability = (prestacion, subnomenclador, enabled) => (dispatch) => {
  return dispatch({
    type: UPDATE_PROVIDED_SERVICE_AVAILABILITY,
    payload: { prestacion, subnomenclador, enabled }
  })
}


export const getProviderServicesByNomenclature = (artId, subnomenclature) => (dispatch) => {
  return dispatch({
    type: GET_PROVIDER_SERVICES_BY_NOMENCLATURA,
    payload: axios
      .get(`providedService/bySubnomenclature?wriId=${artId}&subnomenclature=${subnomenclature}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  });
}

export const deleteProviderPractice = (wriId, serviceId) => (dispatch) => {
  return dispatch({
    type: DELETE_PROVIDER_PRACTICE,
    payload: axios.delete(`providedService/practices?wriId=${wriId}&serviceId=${serviceId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  });
}



export const addProviderPractice = (values) => (dispatch) => {
  return dispatch({
    type: ADD_PROVIDER_PRACTICE,
    payload: axios.post(`providedService/practices`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  })
}

export const changePracticeAvailability = (art, practica, habilitado) => (dispatch) => {
  return dispatch({
    type: CHANGE_PRACTICE_AVAILABILITY,
    payload: axios.put(`providedService/practices/changeAvailability`, { art, practica, habilitado })
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  });
}

export const getPractices = (artId, providerId) => (dispatch) => {
  return dispatch({
    type: GET_PRACTICES,
    payload: axios
      .get(`providedService/practices?wriId=${artId}&providerId=${providerId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => {
        return Promise.reject(error);
      }),
  });
}

export const removeProviderPracticeById = (practiceId) => (dispatch) => {
  return dispatch({
    type: REMOVE_PROVIDER_PRACTICE_BY_ID,
    payload: practiceId
  })
}

export const updateProviderPracticeAvailability = (practiceId, enabled) => (dispatch) => {
  return dispatch({
    type: UPDATE_PROVIDER_PRACTICE_AVAILABILITY,
    payload: { practiceId, enabled }
  })
}